import { Upload } from '@air/redux-uploader';
import { createSelector } from 'reselect';

import { AirState } from '~/store/types';

const publicUploadMetadataSelector = ({ publicUploadMetadata }: AirState) => publicUploadMetadata;
const uploadIdSelector = (_state: AirState, uploadId: Upload['id']) => uploadId;

export const metadataForPublicUploadSelector = createSelector(
  publicUploadMetadataSelector,
  uploadIdSelector,
  (metadata, uploadId) => metadata[uploadId],
);
